<template>
  <svg viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.5 16C8.5 12.6863 11.1863 10 14.5 10H29.5C32.8137 10 35.5 12.6863 35.5 16V29.5C35.5 32.8137 32.8137 35.5 29.5 35.5H14.5C11.1863 35.5 8.5 32.8137 8.5 29.5V16Z"
      stroke="currentColor"
      stroke-width="3"
    />
    <path
      d="M17.5 8.5C17.5 7.67157 16.8284 7 16 7C15.1716 7 14.5 7.67157 14.5 8.5H17.5ZM14.5 13C14.5 13.8284 15.1716 14.5 16 14.5C16.8284 14.5 17.5 13.8284 17.5 13H14.5ZM14.5 8.5V13H17.5V8.5H14.5Z"
      fill="currentColor"
    />
    <path
      d="M29.5 20.5C30.3284 20.5 31 19.8284 31 19C31 18.1716 30.3284 17.5 29.5 17.5V20.5ZM14.5 17.5C13.6716 17.5 13 18.1716 13 19C13 19.8284 13.6716 20.5 14.5 20.5V17.5ZM29.5 17.5H14.5V20.5H29.5V17.5Z"
      fill="currentColor"
    />
    <path
      d="M29.5 31C30.3284 31 31 30.3284 31 29.5C31 28.6716 30.3284 28 29.5 28L29.5 31ZM28 28C27.1716 28 26.5 28.6716 26.5 29.5C26.5 30.3284 27.1716 31 28 31L28 28ZM29.5 28L28 28L28 31L29.5 31L29.5 28Z"
      fill="currentColor"
    />
    <path
      d="M29.5 8.5C29.5 7.67157 28.8284 7 28 7C27.1716 7 26.5 7.67157 26.5 8.5H29.5ZM26.5 13C26.5 13.8284 27.1716 14.5 28 14.5C28.8284 14.5 29.5 13.8284 29.5 13H26.5ZM26.5 8.5V13H29.5V8.5H26.5Z"
      fill="currentColor"
    />
  </svg>
</template>
